







import {isExternal} from '@/utils/validate';

import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component({
  name: 'LinkMenu'
})
export default class LinkMenu extends Vue {
  @Prop({
    type: String,
    required: true
  })
  public to!: string;

  get isExternal() {
    return isExternal(this.to);
  }

  get type() {
    if (this.isExternal) {
      return 'a';
    }
    return 'router-link';
  }

  public linkProps(to) {
    if (this.isExternal) {
      return {
        href: to,
        target: '_blank',
        rel: 'noopener'
      };
    }
    return {
      to: to
    };
  }
}
